import { API } from 'utils';
import managingFeatureToggles from 'utils/managingFeatureToggles';
import {
  ApplicationVersion,
  ApplicationResponse,
  SigmaAvailability,
  EodStateResponse,
  FeatureToggleStateResponse,
  MessageByKey,
  SystemPropertyValueResponse
} from './application.model';
import { RootDispatch } from '../store';

const endpoint = '/version';

const effects = (dispatch: RootDispatch) => ({
  async getApplicationVersion(): Promise<ApplicationVersion | undefined> {
    return API.get<undefined, ApplicationResponse<ApplicationVersion>>(endpoint)
      .then((response) => {
        dispatch.application.storeAppVersion(
          response.data.bffVersion,
          response.data.adapterVersion
        );
        return response.data;
      })
      .catch((error) => error);
  },
  async getSystemMessageByKey(
    messageKey: string
  ): Promise<ApplicationResponse<MessageByKey> | undefined> {
    const url = `/messages/${messageKey}`;
    return API.get<undefined, ApplicationResponse<MessageByKey>>(url)
      .then((response) => response)
      .catch((error) => error);
  },
  async getSigmaAvailability(): Promise<SigmaAvailability | undefined> {
    const url = '/sigma/availability';
    return API.get<undefined, ApplicationResponse<SigmaAvailability>>(
      url,
      false,
      true
    )
      .then((response) => {
        dispatch.application.storeSigmaAvailability(
          response.data.sigmaAvailable
        );
        return response.data;
      })
      .catch((error) => {
        dispatch.application.storeSigmaAvailability(false);
        return error;
      });
  },
  async getEodStatus(): Promise<EodStateResponse | undefined> {
    const url = '/sigma/eod';
    return API.get<undefined, ApplicationResponse<EodStateResponse>>(url)
      .then((response) => {
        dispatch.application.storeEodStatus(response.data);
        if (response.data.eodProcessing) {
          dispatch.application.disablePayments();
        }
        return response.data;
      })
      .catch((error) => error);
  },
  async getFeatureToggleState(featureName: string): Promise<void> {
    const url = `/featuretoggle/state/${featureName}`;
    return API.get<undefined, FeatureToggleStateResponse>(url)
      .then(({ data }) => {
        managingFeatureToggles(featureName, data, dispatch);
      })
      .catch((err) => err);
  },
  async getSystemPropertyValue<T>(
    propertyKey: string
  ): Promise<SystemPropertyValueResponse<T> | undefined> {
    const url = `/systemproperties/${propertyKey}`;
    return API.get<undefined, SystemPropertyValueResponse<T>>(url)
      .then((response) => response)
      .catch((err) => err);
  }
});

export default effects;
